var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_c('el-menu',{attrs:{"default-active":_vm.activeMenu,"mode":"vertical"}},_vm._l((_vm.menulist),function(item){return _c('side-item',{key:item.index,attrs:{"item":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }